import { APIService } from '../../../lib/api/APIService';

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;
      const base64 = dataUrl.indexOf(',') >= 0 ? dataUrl.split(',')[1] : dataUrl;
      resolve(base64);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

class FlashCardsAPI extends APIService {
  async uploadFile(file, appId = null, folderId = null) {
    const base64 = await fileToBase64(file);
    const body = {
      file_base64: base64,
      filename: file.name || 'document.pdf',
      ...(appId && { app_id: appId }),
      ...(folderId && { folder_id: folderId }),
    };
    return this.post('/api/flash-cards/upload', body, { timeout: 120000 });
  }

  async getDecks(appId = null) {
    const q = appId ? `?app_id=${encodeURIComponent(appId)}` : '';
    return this.get(`/api/flash-cards/decks${q}`);
  }

  async getFolders() {
    return this.get('/api/flash-cards/folders');
  }

  async createFolder(name) {
    return this.post('/api/flash-cards/folders', { name });
  }

  async updateFolder(folderId, name) {
    return this.patch(`/api/flash-cards/folders/${folderId}`, { name });
  }

  async updateDeck(deckId, payload) {
    return this.patch(`/api/flash-cards/decks/${deckId}`, payload);
  }

  async getDeck(deckId) {
    return this.get(`/api/flash-cards/decks/${deckId}`);
  }

  async deleteDeck(deckId) {
    return this.delete(`/api/flash-cards/decks/${deckId}`);
  }
}

export const flashCardsAPI = new FlashCardsAPI();
